export default __webpack_public_path__ + "static/media/blueTick.833c7fed.svg";